import { useState, useMemo } from "react";

export interface SortConfig {
  col: string;
  dir: "asc" | "desc" | "";
}

/**
 * Hook to add sorting to a data array.
 */
export function useSort<T extends Record<string, any>>(
  data: T[],
  enableSorting: boolean
) {
  const [sortConfig, setSortConfig] = useState<SortConfig>({ col: "", dir: "" });

  const sortedData = useMemo(() => {
    if (!enableSorting || !sortConfig.dir) return data;
    const factor = sortConfig.dir === "asc" ? 1 : -1;
    return [...data].sort((a, b) =>
      a[sortConfig.col] > b[sortConfig.col]
        ? factor
        : a[sortConfig.col] < b[sortConfig.col]
        ? -factor
        : 0
    );
  }, [data, sortConfig, enableSorting]);

  const toggleSort = (col: string) => {
    setSortConfig((prev) =>
      prev.col !== col
        ? { col, dir: "asc" }
        : { col, dir: prev.dir === "asc" ? "desc" : prev.dir ? "" : "asc" }
    );
  };

  return { sortedData, sortConfig, toggleSort };
}
